module.exports = __webpack_public_path__ + "img/false.c7cae8eb.svg";